import forsythBarrCommon from '@dave-clark-design-associates/forsyth-barr-common/index';

(function ($) {
    forsythBarrCommon.researchIntegrationCreateNavAndAnchors();
    $('.research-integration').find('.scrollbox').each(function(index, el) {
      forsythBarrCommon.researchIntegrationUpdateScrollBoxClasses($(el));
    });
    forsythBarrCommon.researchIntegrationEnableScrollboxes();
})(jQuery);
